import React from 'react';
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { chartColors } from '../../../common/utils';


const TFBar = ( { data, w, h, legend } ) => {
    const keys = Object.keys( data[0] ).filter( f => f !== 'name' );
    
    return (
        // <div className='text-center' style={ { width: w ? w : '100%', height: h ? h : '100%' } }>
            <ResponsiveContainer width={ w ? w : '100%' } height={ h ? h : '100%' }>
                <BarChart data={data} barGap={0}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" interval={0} angle={-15} dy={6} />
                    <YAxis width={35} />
                    <Tooltip />
                    {
                        ( legend ) ? (
                            <Legend verticalAlign='top' height={30} />
                        ) : (
                            null
                        )
                    }
                    {
                        keys.map( ( obj, idx ) => (
                            <Bar key={`tf-bar-${idx}`} dataKey={obj} fill={chartColors[idx]} />
                        ) )
                    }
                </BarChart>
            </ResponsiveContainer>
        // </div>
    )
}

export default TFBar;

